module.exports = __webpack_public_path__ + "img/16.c84b0b1b.png";